module.exports = __webpack_public_path__ + "img/BookGenerator.b5c2fe86.png";